<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> 投票结果 </span>
      <div class="mobile_head_right">
        <a @click="refresh()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteResultInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips">
          共：{{ voteResultInfo.VoteProjectList.length }}
        </div>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div
        class="mobile_project_box"
        v-for="(project, index) in voteResultInfo.VoteProjectList"
        :key="index"
      >
        <div class="project_item">
          <div class="project_title">
            {{ project.Ranking }}、{{ project.ProjectName }}
          </div>
        </div>
        <div class="project_item">
          <i class="el-icon-s-opportunity icon_left icon_primary"></i>
          <div class="content">
            {{ project.Remark }}
          </div>
          <a
            @click="
              project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
            "
          >
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                project.IsShowAdditionalRemark
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
        </div>
        <div class="project_item" v-show="project.IsShowAdditionalRemark">
          <i
            class="el-icon-s-opportunity icon_left icon_warning"
            v-show="project.Remark1"
          ></i>
          <div class="content" v-html="project.Remark1"></div>
        </div>
        <div class="project_item">
          <div class="content">
            <div
              class="font_primary"
              style="
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
              "
              v-if="voteResultInfo.VoteType === 0"
            >
              <div
                style="margin-right: 20px; white-space: nowrap"
                v-for="(stateItem, stateItemIndex) in project.ProjectStateList"
                :key="stateItemIndex"
              >
                {{ stateItem.Value + '：' + stateItem.VoteNumbers }}
              </div>
            </div>
            <span class="font_primary" v-if="voteResultInfo.VoteType === 1">
              当前排序：{{ project.VoteNum }}
            </span>
            <span class="font_primary" v-if="voteResultInfo.VoteType === 2">
              得分：{{ project.AllScore }}
            </span>
          </div>
          <div class="text_right">原序号：{{ project.ProjectSort }}</div>
        </div>
      </div>
    </div>
    <div class="mobile_vote_operate_box">
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        @click="goBack()"
      >
        返回投票
      </el-button>
    </div>
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
export default {
  data () {
    return {
      voteMainStyle: {
        marginTop: '60px'
      },
      voteResultInfo: {
        VoteProjectList: []
      }
    }
  },
  methods: {
    goBack: function () {
      if (this.voteResultInfo.VoteType === 0) {
        this.$router.push({ name: 'shortlist', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
      }
      if (this.voteResultInfo.VoteType === 1) {
        this.$router.push({ name: 'sort', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
      }
      if (this.voteResultInfo.VoteType === 2) {
        this.$router.push({ name: 'score', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
      }
    },
    refresh: function () {
      this.getVoteResult()
    },
    getVoteResult: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResultInfo = data
        _this.voteResultInfo.VoteProjectList.forEach(item => {
          _this.$set(item, 'IsShowAdditionalRemark', false)
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    }
  },
  created () {
    this.getVoteResult()
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
</style>
